import { getKeyLabel } from '@bettermode/common/keyboard'

export const COMMAND_BAR_HOTKEYS = {
  ASK_AI: {
    value: 'mod+j',
    label: `${getKeyLabel('cmd')} + j`,
  },
  SEARCH: {
    value: 'mod+/',
    label: `${getKeyLabel('cmd')} + /`,
  },
  COMMANDS: {
    value: 'mod+k',
    label: `${getKeyLabel('cmd')} + k`,
  },
}
